module.exports = __webpack_public_path__ + "static/media/img_7.8416718e.png";